import MobileHeader from '../__header/mobileHeader';

const $ = jQuery.noConflict();
const pageSections = $('.acf-block[id]').get().reverse();
const header = $('.main-header');
const nav = $('.main-header__nav');
const $inpageNav = $('.main-header__nav');
const mobileBtn = $('.main-header__mobile-btn');

function scrollFunc(e) {
    e.preventDefault();
    const header = $('.main-header');
    const target = $($(this).attr('href'));
    let stickyHeight = header.outerHeight() - 5;

    if ($(this).attr('href') === '#next' && $(this).parents('section').next().length > 0) {
        // Smooth Scroll to next section
        $('html, body').animate({
            scrollTop: $(this).parents('section').next().offset().top - stickyHeight,
        }, 600);
        MobileHeader.hideWrapper('.main-header', $('body'));
    } else if (target.length) {
        let offsetTop = target.offset().top
        const pt = parseInt(target.css('padding-top'), 10)
        
        if ( 0 === pt ) {
            offsetTop -= 60
        }

        $('html, body').animate({
            scrollTop: offsetTop - stickyHeight,
        }, 600);
        MobileHeader.hideWrapper('.main-header', $('body'));
        mobileBtn.removeClass('open');
    }

    $('body').addClass('smooth-scrolling');
    setTimeout(() => {
        $('body').removeClass('smooth-scrolling');
    }, 600)
}

function setActiveNavElement(el) {
    if ( el !== undefined ) {
        const $links = $inpageNav.find('a');

        let $currentLink = $inpageNav.find(`a[href="#${el.id}"]`);
        let counter = 0;

        while ( ! $currentLink.length && counter < 50 && null !== el ) {
            el = el.previousSibling
            if ( null !== el ) {
                $currentLink = $inpageNav.find(`a[href="#${el.id}"]`);
            }
            counter++;
        }

        $links.blur().parent().removeClass('active');
        $currentLink.parent().addClass('active');
        mobileBtn.text( $currentLink.text() )
    }
}

window.scrollPrevEl = null;
const markCurrentNavItem = () => {
    if (nav.length > 0) {
        const navBottomOffset = header.offset().top + header.outerHeight();

        const currentSection = pageSections.find((section) => {
            const el = $(section);
            const mt = parseInt(el.css('margin-top'), 10);
            const pt = parseInt(el.css('padding-top'), 10);
            let offset = 0;

            if (mt > 0 && pt === 0 ) {
                offset = mt;
            }

            return el.is(':visible') && navBottomOffset > el.offset().top - offset;
        });
        
        if (currentSection && !$('body').hasClass('smooth-scrolling') && currentSection !== window.scrollPrevEl) {
            setActiveNavElement(currentSection);
            window.scrollPrevEl = currentSection;
        }
    }
}

function smoothScroll() {
    $('a[href^="#"]:not([href="#"])').on('click', scrollFunc);
}
export { smoothScroll as default, markCurrentNavItem };
